import { render, staticRenderFns } from "./SectionExplainer.vue?vue&type=template&id=a347276a&scoped=true&"
import script from "./SectionExplainer.vue?vue&type=script&lang=js&"
export * from "./SectionExplainer.vue?vue&type=script&lang=js&"
import style0 from "./SectionExplainer.vue?vue&type=style&index=0&id=a347276a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a347276a",
  null
  
)

export default component.exports